import React from 'react';
import { Button } from 'react-bootstrap';
import Dialog from './Dialog';
import { withTranslation } from 'react-i18next';

const MessageBox = ({ title, message, onConfirm, onCancel, t, ...rest }) => {
	const footer = (
		<div>
			<Button bsStyle='primary' onClick={onConfirm}>{t('Common_Yes')}</Button>
			<Button onClick={onCancel}>{t('Common_No')}</Button>
		</div>
	);
	return <Dialog config={{ header: title, body: message, onHide: onCancel, footer: footer }} {...rest} />;
};

export default withTranslation()(MessageBox);